import fb, { getDocsFromCollection } from '@/firebase'
import store from '@/store'

const state = {
  pendingAssociates: null,
  authorizedAssociates: null,
  rejectedAssociates: null,
  onholdAssociates: null
}

const getters = {
  pendingAssociates: state => state.pendingAssociates,
  authorizedAssociates: state => state.authorizedAssociates,
  rejectedAssociates: state => state.rejectedAssociates,
  onholdAssociates: state => state.onholdAssociates
}

const mutations = {
  setPendingAssociates: (state, payload) => {
    state.pendingAssociates = payload
  },
  setAuthorizedAssociates: (state, payload) => {
    state.authorizedAssociates = payload
  },
  setRejectedAssociates: (state, payload) => {
    state.rejectedAssociates = payload
  },
  setOnholdAssociates: (state, payload) => {
    state.onholdAssociates = payload
  }
}

const actions = {
  setPendingAssociates: ({commit}, payload) => {
    commit('setPendingAssociates', payload)
  },
  setAuthorizedAssociates: ({commit}, payload) => {
    commit('authorizedAssociates', payload)
  },
  setRejectedAssociates: ({commit}, payload) => {
    commit('rejectedAssociates', payload)
  },
  setOnholdAssociates: ({commit}, payload) => {
    commit('onholdAssociates', payload)
  },
  getPendingAssociates: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getPendingAssociates()
      .then((fetched) => {
        commit('setPendingAssociates', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getAuthorizedAssociates: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getAuthorizedAssociates()
      .then((fetched) => {
        commit('setAuthorizedAssociates', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getRejectedAssociates: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getRejectedAssociates()
      .then((fetched) => {
        commit('setRejectedAssociates', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getOnholdAssociates: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getOnholdAssociates()
      .then((fetched) => {
        commit('setOnholdAssociates', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  updateAssocStatus ({commit}, params) {
    store.dispatch('setLoaderStatus', true)
    fb.updateUserDetails(params.uid, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        if (params.payload.status === 'Authorized' || params.onView === 'authorized_assoc') {
          store.dispatch('getAuthorizedAssociates')
        }
        if (params.payload.status === 'Rejected' || params.onView === 'rejected_assoc') {
          store.dispatch('getRejectedAssociates')
        }
        if (params.payload.status === 'On Hold' || params.onView === 'onhold_assoc') {
          store.dispatch('getOnholdAssociates')
        }
        if (params.onView === 'pending_assoc') {
          store.dispatch('getPendingAssociates')
        }
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/associates.js